export const MIN_WIDTH_SM = 768;
export const MAX_WIDTH_SM = 991;
export const MIN_WIDTH_MD = 992;
export const MIN_WIDTH_LG = 1200;
